import React from "react";
import { BsFacebook, BsLinkedin, BsTwitterX } from "react-icons/bs";
import styled from "styled-components";


const Root = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 20px;
  a {
    text-decoration: none;
  }
`
export const SocialShare: React.FC<{url?: string; title?: string}> = ({
  url, title
}) => {
  const shareUrl = encodeURIComponent(url || window.location.href);
  const text = encodeURIComponent(title||"");
  
  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 10}}>
      <Root>
        <a href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${text}`} target="_blank" rel="noreferrer">
          <BsTwitterX size={24} color="#1DA1F2"/>
        </a>
        <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${text}`}
            target="_blank"
            rel="noreferrer"
          >
            <BsFacebook size={24} color="#3b5998"/>
          </a>

          {/* LinkedIn */}
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}&title=${text}&summary=${text}`}
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin size={24} color="#0077B5"/>
          </a>
      </Root>
      Share on social media
    </div>
  )
};
